import { useQueryClient } from 'react-query';
import { OffsiteCampaign } from 'models/offsite/Campaign/OffsiteCampaign';

export function useOffsiteCampaignsCache(siteId: string) {
  const queryClient = useQueryClient();
  const addCampaignToCache = (newCampaign: OffsiteCampaign) => {
    queryClient.setQueryData(['offsite-campaigns', siteId], (old: OffsiteCampaign[] = []) => [newCampaign, ...old]);
  };
  return { addCampaignToCache };
}
